import dayjs from 'dayjs';

import { SxProps, Tooltip, Typography, Stack } from '@cast/design-system';
import { getTimeAgo, toDateTimePrecise } from '@cast/utils';

import { CopyToClipboard } from 'components/clickable-actions';

type Props = {
  time?: string;
  formattedDate?: string;
  distance?: string;
  noTooltip?: boolean;
  sx?: SxProps;
};

export const TimeAgo = ({
  time,
  formattedDate,
  distance,
  noTooltip,
  sx,
}: Props) => {
  if (!time && (!formattedDate || !distance)) {
    return null;
  }

  const date = time ? toDateTimePrecise(time) : formattedDate;
  const ago = time ? getTimeAgo(time, true) : distance;

  if (!date && !ago) {
    return null;
  }

  return (
    <Tooltip
      arrow
      placement="bottom"
      size="small"
      wrapIf={!noTooltip}
      title={
        <Stack direction="row" alignItems="center" gap={4} color="#fff">
          <Typography variant="inherit" color="inherit">
            {date}
          </Typography>

          <CopyToClipboard color="#fff" iconSize={14} text={date!} />
        </Stack>
      }
    >
      <Typography
        noWrap
        variant="inherit"
        component="p"
        data-sortweight={date ? dayjs(date).unix() : undefined}
        sx={sx}
      >
        {ago}
      </Typography>
    </Tooltip>
  );
};
